<template>
  <FilterSelectorItem
    data-testid="filterCategory"
    :label="filterLabel"
    :options="categoryFilter.options"
    :variant="variant"
    @option-selected="handleFilterChange"></FilterSelectorItem>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import FilterSelectorItem from "@/components/archive/FiltersSelector/FilterSelectorItem.vue";
import useFilterItem from "@/composition/archive/useFilterItem.ts";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";

import type { FilterSelectorItemWrapperProps } from "./filterSelectorItemWrapper";

defineProps<FilterSelectorItemWrapperProps>();

const filterSelectorStore = useFilterSelectorStore();
const { categoryFilter, selectedCategories } = storeToRefs(filterSelectorStore);
const { handleFilterChange, filterLabel } = useFilterItem(
  categoryFilter,
  selectedCategories,
);
</script>
